import type { UserLoginPayload } from "src/types";
import Repository from "./repository";

const resource = "/token";

export default {
  get(user: UserLoginPayload) {
    return Repository.post(`${resource}/`, user);
  },
  refresh(refreshToken: string) {
    return Repository.post(`${resource}/refresh/`, { refresh: refreshToken });
  },
};
